export default __webpack_public_path__ + "static/media/gallery10.cb4720e6.jpg";